(function () {
    'use strict';

    var KeepAliveTracking = function(opts) {
        var self = this;
        var tracker = opts.tracker;
        var model = opts.model;

        var timerID = null;
        var startKeepAlive = 0;
        var keepAliveCount = 0;
        var keepAliveFocus = [];

        var MAX_COUNT = 10000;
        var INACTIVITY_LIMIT = 310000; 
        var KEEP_ALIVE_INTERVAL = model.get('keepAliveInterval');

        this.setupTracking = setupTracking;
        this.resetInactivity = resetInactivity;

        function setupTracking() {
            if (timerID) {
                return;
            }
            timerID = setInterval(function () {
                if (keepAliveCount >= MAX_COUNT || (startKeepAlive && (Date.now() - startKeepAlive) >= INACTIVITY_LIMIT)) {
                    clearInterval(timerID);
                    timerID = 0;
                    return;
                }
                if (!startKeepAlive) {
                    startKeepAlive = Date.now();
                }
                ++keepAliveCount;
                keepAliveFocus.push(document.hasFocus());
                tracker.track(tracker.trackingEvents.KEEP_ALIVE, {
                    focus: keepAliveFocus
                });
            }, KEEP_ALIVE_INTERVAL);
            return timerID;
        }
        function resetInactivity() {
            startKeepAlive = Date.now();
        }
    };

    var publicAPI = {};
    publicAPI.create = function(opts) {
        return new KeepAliveTracking(opts);
    };

    cylindo.addModule('tracking.keepAlive', publicAPI);
}).call(this);